import React from "react";
import FireExtingulsher from "./FireExtingulsher";
import MainDashboardLayout from "../../../Layout/MainDashboardLayout";
import Scope1Layout from "../../../Layout/Scope1Layout";
import Unauthorized from "../../../Components/Unauthorized/Unauthorized";

const Fugitive = () => {
  return (
    <MainDashboardLayout sidebar={<Scope1Layout />}>
      <Unauthorized requiredModule="Environment | Scope 1 | Fugitive Emissions">
        <FireExtingulsher />
      </Unauthorized>
    </MainDashboardLayout>
  );
};

export default Fugitive;
